import {
    useCallback,
} from 'react'

import usePrintContainerLabels from 'app/Apps/ContainerManagement/Containers/hooks/usePrintContainerLabels'
import useLabel from 'app/hooks/useLabel'
import {
    Container,
} from 'app/Apps/ContainerManagement/Containers/containers.types'

import PrintLabelOverview from './PrintLabelOverview'

type Props = {
    value: Pick<Container, 'serialNumber' | 'containerType'>
}

const PrintLabelOverviewContainer = ({
    value,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        serialNumber,
        containerType: {
            containerCode,
        },
    } = value
    const containerSerialNumber = serialNumber.slice(4)
    const {
        mutate: printLabelRequest,
    } = usePrintContainerLabels({
        loadMessage: l('PLEASE_STAND_BY_WHILE_PREPARING_THE_BARCODES'),
    })

    const printLabel = useCallback(() => {
        printLabelRequest({
            containerSerialNumberTo: containerSerialNumber,
            containerSerialNumberFrom: containerSerialNumber,
            containerCode,
            label: `labels_${containerCode}_${containerSerialNumber}-${containerSerialNumber}`,
        })
    }, [
        containerCode,
        containerSerialNumber,
        printLabelRequest,
    ])

    return (
        <PrintLabelOverview
            printLabel={printLabel}
        />
    )
}

export default PrintLabelOverviewContainer
